$(document).ready(function () {

    var bundle_cart_products = [];

    // Function to get total quantity across all selected products
    function getTotalQuantity() {
        var total = 0;
        $('.bundlekit-product-grid-item.selected').each(function() {
            var quantity = parseInt($(this).find('.bundlekit-quantity-input').val()) || 1;
            total += quantity;
        });
        return total;
    }

    function showDefaultProgressMarkup() {
        $('.discount_text_1,.discount_text_2').removeClass('hidden');
        $('.wi_bundle_success_text').addClass('hidden');
    }

    function loadSuccessProductsMarkup(bundle_cart_products) {

        var success_products_markup = '';
        for (let i = 0; i < bundle_cart_products.length; i++) {
            const product = bundle_cart_products[i];
            var product_quantity = product.product_quantity || 1;
            success_products_markup += `
            <div class="grid__item bundlekit-product-grid-item grid-product small--one-half medium-up--one-quarter">
                <div class="card">
                    <div class="card--image">
                        <img src="${product.product_image}" alt="${product.product_title}">
                    </div>
                    <div class="card--content">
                        <h3 class="card--title">${product.product_title}</h3>
                        <p class="card--quantity text-center">Qty: ${product_quantity}</p>
                        <p class="card--vendor">${product.product_vendor}</p>
                    </div>
                </div>
            </div>`;
        }

        $('.wi_bundle_products_list').html(success_products_markup);
    }
    function updateBundleProgressBar() {
        var total_quantity = getTotalQuantity();
    
        // Parse discount and min product attributes, defaulting to NaN if not available
        var layer1_discount = parseInt($('.wi_discount_bar').attr('data-layer1_discount')) || 0;
        var layer2_discount = parseInt($('.wi_discount_bar').attr('data-layer2_discount')) || 0;
        var layer3_discount = parseInt($('.wi_discount_bar').attr('data-layer3_discount')) || 0;
        
        var layer1_min_products = parseInt($('.wi_discount_bar').attr('data-layer1_min_products')) || NaN;
        var layer2_min_products = parseInt($('.wi_discount_bar').attr('data-layer2_min_products')) || NaN;
        var layer3_min_products = parseInt($('.wi_discount_bar').attr('data-layer3_min_products')) || NaN;
    
        showDefaultProgressMarkup();
    
        var progress = 0;  // Initialize progress 
    
        // If only Layer 1 is available
        if (!isNaN(layer1_min_products) && isNaN(layer2_min_products) && isNaN(layer3_min_products)) {
            if (total_quantity < layer1_min_products) {
                $('.wi_total_discount').text(layer1_discount + '%');
                $('.wi_total_product').text(layer1_min_products - total_quantity);
            } else {
                $('.discount_text_1,.discount_text_2').addClass('hidden');
                $('.wi_bundle_success_text .discount_number').text(layer1_discount + '%');
                $('.wi_bundle_success_text').removeClass('hidden');
            }
            progress = Math.min((total_quantity / layer1_min_products) * 100, 100);
        }
        // If Layer 1 and Layer 2 are available, but not Layer 3
        else if (!isNaN(layer1_min_products) && !isNaN(layer2_min_products) && isNaN(layer3_min_products)) {
            if (total_quantity < layer1_min_products) {
                $('.wi_total_discount').text(layer1_discount + '%');
                $('.wi_total_product').text(layer1_min_products - total_quantity);
                progress = Math.min((total_quantity / layer1_min_products) * 100, 100);
            } 
            else if (total_quantity < layer2_min_products && total_quantity >= layer1_min_products) {
                $('.wi_total_discount').text(layer2_discount + '%');
                $('.wi_total_product').text(layer2_min_products - total_quantity);
                progress = Math.min((total_quantity / layer2_min_products) * 100, 100);
            } 
            else {
                $('.discount_text_1,.discount_text_2').addClass('hidden');
                $('.wi_bundle_success_text .discount_number').text(layer2_discount + '%');
                $('.wi_bundle_success_text').removeClass('hidden');
                progress = 100; // Max out progress if layer 2 is fulfilled
            }
        }
        // If all three layers are available
        else if (!isNaN(layer1_min_products) && !isNaN(layer2_min_products) && !isNaN(layer3_min_products)) {
            if (total_quantity < layer1_min_products) {
                $('.wi_total_discount').text(layer1_discount + '%');
                $('.wi_total_product').text(layer1_min_products - total_quantity);
                progress = Math.min((total_quantity / layer1_min_products) * 100, 100);
            } 
            else if (total_quantity < layer2_min_products && total_quantity >= layer1_min_products) {
                $('.wi_total_discount').text(layer2_discount + '%');
                $('.wi_total_product').text(layer2_min_products - total_quantity);
                progress = Math.min((total_quantity / layer2_min_products) * 100, 100);
            } 
            else if (total_quantity < layer3_min_products && total_quantity >= layer2_min_products) {
                $('.wi_total_discount').text(layer3_discount + '%');
                $('.wi_total_product').text(layer3_min_products - total_quantity);
                progress = Math.min((total_quantity / layer3_min_products) * 100, 100);
            } 
            else {
                $('.discount_text_1,.discount_text_2').addClass('hidden');
                $('.wi_bundle_success_text .discount_number').text(layer3_discount + '%');
                $('.wi_bundle_success_text').removeClass('hidden');
                progress = 100; // Max out progress if layer 3 is fulfilled
            }
        }
    
        // Update the progress bar with the final progress
        $('.wi_test_discount_progress_bar').css('width', progress + '%');
    }
    
    
    // function updateBundleProgrdessBar() {
    //     var selected_items = $('.bundlekit-product-grid-item.selected');
    //     showDefaultProgressMarkup();
    //     if (selected_items.length < 10) {
    //         $('.wi_total_discount').text('10%');
    //         $('.wi_total_product').text(10 - selected_items.length);
    //     }
    //     else if (selected_items.length < 15 && selected_items.length >= 10) {
    //         $('.wi_total_discount').text('15%');
    //         $('.wi_total_product').text(15 - selected_items.length);
    //     }
    //     else if (selected_items.length < 20 && selected_items.length >= 15) {
    //         $('.wi_total_discount').text('20%');
    //         $('.wi_total_product').text(20 - selected_items.length);
    //     }
    //     else if (selected_items.length >= 20) {
    //         $('.discount_text_1,.discount_text_2').addClass('hidden');
    //         $('.wi_bundle_success_text').removeClass('hidden');
    //     }

    //     if (selected_items.length == 20) {
    //         var progress = (selected_items.length / 20) * 100;
    //         $('.wi_test_discount_progress_bar').css('width', progress + '%');
    //     }
    //     else {
    //         var progress = (selected_items.length / 20) * 100;
    //         $('.wi_test_discount_progress_bar').css('width', progress + '%');
    //     }
    // }
    
    var autoscrolled = false;
    var layer1_min_products = parseInt($('.wi_discount_bar').attr('data-layer1_min_products')) || 0;
    
    // Handle product selection/deselection
    $(document).on('click', '.bundlekit-product-grid-item', function (e) {
        // Don't toggle if clicking on quantity buttons
        if ($(e.target).closest('.bundlekit-quantity-selector').length > 0) {
            return;
        }

        if ($(this).parents('.wi_bundle_success').length > 0) {
            return false;
        }
        
        $('.wi_error_message').addClass('hidden');

        // If not selected, select it with quantity 1
        if (!$(this).hasClass('selected')) {
            $(this).addClass('selected');
            $(this).find('.product-cart-button').addClass('hidden');
            $(this).find('.bundlekit-quantity-selector').removeClass('hidden');
            $(this).find('.bundlekit-quantity-input').val(1);
            updateBundleProgressBar();
            
            // Auto-scroll when minimum is reached
            if (getTotalQuantity() >= layer1_min_products && autoscrolled == false) {
                autoscrolled = true;
                $('html, body').animate({ scrollTop: $('.wi_button_wrapper').offset().top }, 'slow');
            }
        }
    });

    // Handle quantity increase
    $(document).on('click', '.bundlekit-quantity-increase', function (e) {
        e.stopPropagation();
        var $item = $(this).closest('.bundlekit-product-grid-item');
        var $input = $(this).siblings('.bundlekit-quantity-input');
        var currentVal = parseInt($input.val()) || 1;
        $input.val(currentVal + 1);
        updateBundleProgressBar();
        
        // Auto-scroll when minimum is reached
        var layer1_min_products = parseInt($('.wi_discount_bar').attr('data-layer1_min_products')) || 0;
        if (getTotalQuantity() >= layer1_min_products && autoscrolled == false) {
            autoscrolled = true;
            $('html, body').animate({ scrollTop: $('.wi_button_wrapper').offset().top }, 'slow');
        }
    });

    // Handle quantity decrease
    $(document).on('click', '.bundlekit-quantity-decrease', function (e) {
        e.stopPropagation();
        var $item = $(this).closest('.bundlekit-product-grid-item');
        var $input = $(this).siblings('.bundlekit-quantity-input');
        var currentVal = parseInt($input.val()) || 1;
        
        if (currentVal > 1) {
            $input.val(currentVal - 1);
            updateBundleProgressBar();
        } else {
            // Remove selection if quantity goes to 0
            $item.removeClass('selected');
            $item.find('.product-cart-button').removeClass('hidden');
            $item.find('.bundlekit-quantity-selector').addClass('hidden');
            $input.val(1);
            updateBundleProgressBar();
        }
    });

  


    // Add to cart button

    $(document).on('click', '.wi_bundle_add_to_cart', function (e) {
        e.preventDefault();

        var total_quantity = getTotalQuantity();
        var layer1_min_products = parseInt($('.wi_discount_bar').attr('data-layer1_min_products')) || 0;

        if (total_quantity < layer1_min_products) {
            $('.wi_error_message').removeClass('hidden');
            return false;
        }

        removeExistingBundle(function () {
            var selected_items = $('.bundlekit-product-grid-item.selected');
            let formData = {
                'items': []
            };

            bundle_cart_products = []; // Reset cart products array

            for (let i = 0; i < selected_items.length; i++) {
                const selected_item = selected_items[i];
                var variant_id = $(selected_item).attr('data-variant-id');
                var quantity = parseInt($(selected_item).find('.bundlekit-quantity-input').val()) || 1;
                
                formData.items.push({
                    'id': variant_id,
                    'quantity': quantity,
                    'properties': {
                        '_type': 'bundle_product'
                    }
                });

                // Add product info once per product (not per quantity)
                bundle_cart_products.push({
                    'product_image': $(selected_item).attr('data-product-image'),
                    'product_title': $(selected_item).attr('data-product-title'),
                    'product_vendor': $(selected_item).attr('data-product-vendor'),
                    'product_quantity': quantity
                });
            }

            $.ajax({
                url: '/cart/add.js',
                type: 'POST',
                data: formData,
                dataType: 'json',
                success: function (data) {

                    $('.wi_bundle_success').removeClass('hidden');
                    $('.wi_product_grid').addClass('hidden');
                    $('.wi_bundle_success_cart').removeClass('hidden');
                    $('.discount_text_1').addClass('hidden');
                    $('.discount_text_2').addClass('hidden');
                    $('.wi_button_wrapper').addClass('hidden');
                    $('.pagination').addClass('hidden');
                    $('.success_btn_wrapper').removeClass('hidden');
                    loadSuccessProductsMarkup(bundle_cart_products);
                    $('html, body').animate({ scrollTop: $('.wi-collection-banner').offset().top }, 'slow');
                    $('.wi_test_discount_progress_bar').css('width', '100%');

                    var customCartDrawer = new theme.CartDrawer();
                    setTimeout(() => {
                        getUpsell_data();
                        customCartDrawer.open();
                    }, 2000);


                },
                error: function (data) {
                    console.log(data);
                }
            });
        });


    }
    );


    // loadmore pagination
    $(document).on('click', '.load-more-btn', function () {
        // load-more-btn
        // write jQuery ajax on 'data-next-page-url' to get next page product's html and append it to .wi_product_grid
        var next_page_url = $(this).attr('data-next-page-url');
        $.ajax({
            url: next_page_url,
            type: 'GET',
            success: function (responseText) {
                var parser = new DOMParser();
                var doc = parser.parseFromString(responseText, "text/html");
                var $newItems = $(doc).find('.wi_product_grid').html();
                $('.wi_product_grid').append($newItems);
                var $newPagination = $(doc).find('.load-more-btn-wrapper');
                $('.load-more-btn-wrapper').replaceWith($newPagination);
                $('.image-wrap img').on('load', function() {
                    $(this).css('opacity', '1');
                });
            }
        });


    });

    

});